/**
 * The one code-based route tree (spec §6.3). Each feature exports its routes as an array from
 * `features/<domain>/routes.ts` (attached to `appRoute`); they're spread in here, so adding a screen
 * never touches this file. Pages not rebuilt yet fall through to the splat route (a placeholder).
 */
import { createRoute, redirect } from '@tanstack/react-router';
import { adminRoutes } from '@/features/admin/routes';
import { analyticsRoutes } from '@/features/analytics/routes';
import { bonusRoutes } from '@/features/bonus/routes';
import { brandsRoutes } from '@/features/brands/routes';
import { configsRoutes } from '@/features/configs/routes';
import { currenciesRoutes } from '@/features/currencies/routes';
import { gamesRoutes } from '@/features/games/routes';
import { operatorsRoutes } from '@/features/operators/routes';
import { playersRoutes } from '@/features/players/routes';
import { promotionsRoutes } from '@/features/promotions/routes';
import { roundsRoutes } from '@/features/rounds/routes';
import { appRoute, loginRoute, rootRoute } from './layout-routes';
import { HomePage } from './pages/home-page';
import { PlaceholderOrNotFound } from './pages/status-pages';

const homeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  // The analytics Overview is the landing page for everyone who can see it (spec §7.1).
  beforeLoad: ({ context }) => {
    if (context.auth.can('VIEW_LIST_GAMES')) throw redirect({ to: '/analytics', replace: true });
  },
  component: HomePage,
});
const splatRoute = createRoute({ getParentRoute: () => appRoute, path: '$', component: PlaceholderOrNotFound });

export const routeTree = rootRoute.addChildren([
  loginRoute,
  appRoute.addChildren([
    homeRoute,
    ...analyticsRoutes,
    ...currenciesRoutes,
    ...gamesRoutes,
    ...configsRoutes,
    ...operatorsRoutes,
    ...brandsRoutes,
    ...promotionsRoutes,
    ...playersRoutes,
    ...roundsRoutes,
    ...bonusRoutes,
    ...adminRoutes,
    splatRoute,
  ]),
]);
